export enum EExchangeState {
  NOT_EXCHANGING = 'NOT_EXCHANGING',
  ENTER_PASSWORD = 'ENTER_PASSWORD',
  EXCHANGE_IN_FLIGHT = 'EXCHANGE_IN_FLIGHT',
  EXCHANGE_COMPLETE = 'EXCHANGE_COMPLETE',
}

export interface ICustomRevealState {
  currentVideoState: string;
  videoBoxType: string;
  shouldLoop: boolean;
  totalCards: number;
  loaded: string[];
  revealed: string[];
  showCards: boolean;
  videoReady: boolean;
}

export interface ILockedItem {
  locked?: boolean;
  lockedUntil?: string;
  allowedActions?: string[];
  tokenInstanceId?: string;
}

export interface IExchangeReward {
  name: string;
  game: string;
  image: string;
  quantity: string;
  instance: string;
  collection: string;
  category: string;
  type: string;
  additionalKey: string;
}
